import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ARadio = _resolveComponent("ARadio")!

  return (_openBlock(), _createBlock(_component_ARadio, {
    checked: _ctx.modelValue,
    "onUpdate:modelValue": _ctx.check
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["checked", "onUpdate:modelValue"]))
}